import { useEffect, useState } from 'react';
import { SearchBoxState, SearchBox as SearchBoxComponent } from '@coveo/headless';
import { SearchSuggestionInput } from './SearchSuggestionInput';
import { UrlParamNameSearch } from '../Helpers/AppHelper';
import { ReactHelper } from 'Utilities/ReactHelper';

interface ISearchboxProps {
  searchBox: React.MutableRefObject<SearchBoxComponent>;
}
export function SearchBox({ searchBox }: ISearchboxProps) {
  const [searchBoxState, setSearchBoxState] = useState<SearchBoxState>(searchBox.current.state);

  useEffect(() => {
    const unsub = searchBox.current.subscribe(() => {
      setSearchBoxState(searchBox.current.state);
    });
    return function cleanup() {
      unsub();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const onChange = (value: string) => {
    searchBox.current.updateText(value);
  };
  const onSubmit = () => {
    if (searchBox.current.state.value !== '') {
      // Adding search terms to url makes page bookmarkable and back button navigation to re-search
      ReactHelper.addUrlParamWithoutRefresh(UrlParamNameSearch, searchBox.current.state.value);
    }
    searchBox.current.submit();
  };
  const onSuggestionClick = (value: string) => {
    searchBox.current.selectSuggestion(value);
  };

  return (
    <>
      {searchBoxState && (
        <>
          <SearchSuggestionInput
            label="Search"
            state={searchBoxState}
            onChange={onChange}
            onSubmit={onSubmit}
            onSuggestionClick={onSuggestionClick}
            autoFocus={true}
          />
        </>
      )}
    </>
  );
}
